// Paso6Aprobacion.jsx
import React from 'react';
import { Card, Result, Button } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

export default function Paso6Aprobacion({ nombreTaller, onFinish }) {
  return (
    <Card>
      <Result
        icon={<InfoCircleOutlined style={{ color: '#1677ff' }} />}
        title={`Taller "${nombreTaller}" enviado a aprobación`}
        subTitle="Un coordinador o administrador debe revisar y aprobar tu taller antes de estar disponible."
        extra={
          <Button type="primary" onClick={onFinish}>
            Volver a la lista de talleres
          </Button>
        }
      />
    </Card>
  );
}
